import React, { useState } from "react";
import { TextField, Button, Typography } from "@mui/material";

const CodeForm = (props) => {
  const { handleForm, isLoading, recaptcha } = props;
  // const [inputValue, setInputValue] = useState("111111");
  // const [inputValue, setInputValue] = useState("555555");
  const [inputValue, setInputValue] = useState("");

  function onSubmit(event) {
    event.preventDefault();

    handleForm(inputValue);
  }

  return <>
    <form onSubmit={onSubmit}>
      <Typography
        color="text.secondary"
        variant="body2"
        sx={{ mb: 2 }}
      >
        Enter the code you received on your phone
      </Typography>

      <TextField 
        label="Code"
        onChange={e => setInputValue(e.target.value)}
        required
        variant="outlined"
        color="secondary"
        type="text"
        fullWidth
        value={inputValue}
       />

       {recaptcha && <div id="recaptcha-container" />}

       <Button
         variant="contained"
         disabled={isLoading}
         color="secondary"
         fullWidth
         type="submit"
         sx={{ mt: 3, mb: 2 }}
        >
          Log in
        </Button>
    </form>
  </>
}

export default CodeForm;
